export default "__VITE_ASSET__0e4ecf3d__"